interface UseLocalStorageReturn<T> {
	getCurrentValue(): T
	clearCurrentValue(): void
	setValue(newValue: T): void
}

export const useLocalStorage = <T>(key: string, defaultValue: T): UseLocalStorageReturn<T> => {
	const clearCurrentValue = () => localStorage.removeItem(key)
	const setValue = (value: T) => {
		if (!value) clearCurrentValue()
		else localStorage.setItem(key, JSON.stringify(value))
	}
	const getCurrentValue = () => {
		const stringValue = localStorage.getItem(key)
		return stringValue ? JSON.parse(stringValue || `${defaultValue}`) : defaultValue
	}

	return { clearCurrentValue, setValue, getCurrentValue }
}
